module.exports = __webpack_public_path__ + "img/field_mapping_arrow.0970a8a3.svg";